import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export { isMediaClientError, getMediaClientErrorReason } from './helpers';

/**
 * Base class for media errors
 */
export var BaseMediaClientError = /*#__PURE__*/function (_Error) {
  _inherits(BaseMediaClientError, _Error);
  var _super = _createSuper(BaseMediaClientError);
  function BaseMediaClientError(message) {
    var _this;
    _classCallCheck(this, BaseMediaClientError);
    _this = _super.call(this, message);

    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    _this.message = message;
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof BaseMediaClientError ? this.constructor : void 0).prototype);

    // https://v8.dev/docs/stack-trace-api
    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(_assertThisInitialized(_this), this instanceof BaseMediaClientError ? this.constructor : void 0);
    }
    return _this;
  }
  return _createClass(BaseMediaClientError);
}( /*#__PURE__*/_wrapNativeSuper(Error));